import * as React from 'react';
import { useState, useEffect } from 'react';
import { Row } from 'saladsoft-primitive';
import styled from 'styled-components';
import { ItemType } from './types';

const ItemBox = ({
  item,
  onSelect,
  checked,
  style,
  usePhoto = true,
}: {
  item: ItemType;
  checked?: boolean;
  onSelect: (item: ItemType, checked: boolean) => void;
  usePhoto?: boolean;
  style?: React.CSSProperties;
}) => {
  const [isChecked, setIsChecked] = useState(checked ?? false);

  const handleButtonClick = (e: any) => {
    e.stopPropagation();
    onSelect(item, !isChecked);
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    setIsChecked(checked ?? false);
  }, [checked]);

  return (
    <CardContainer checked={isChecked ?? false} useSelect={true} onClick={handleButtonClick} style={style}>
      {usePhoto && item.imageUrl && <WineImage loading="lazy" src={item.imageUrl} alt={item.name} />}
      <ProductInfo>
        <Row alignItems="flex-start">
          <ProductTitle>
            {item.name.length > 10 ? `${item.name.slice(0, 10)}...` : item.name}
          </ProductTitle>
        </Row>
      </ProductInfo>
    </CardContainer>
  );
};

const CardContainer = styled.div<{ checked: boolean; useSelect: boolean }>`
  align-self: stretch;
  cursor: ${(props) => (props.useSelect ? 'pointer' : 'default')};
  border-radius: 12px;
  border: ${(props) => (props.checked ? '3px solid var(--point-color)' : '3px solid transparent')};
  background: var(--Grayscale-0, #fff);
  display: flex;
  flex-direction: column;
  justify-content: start;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
`;

const WineImage = styled.img`
  object-fit: cover;
  object-position: center;
  width: 250px;
  aspect-ratio: 3/2;
  border-radius: 10px 10px 0 0px;
`;

const ProductInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Pretendard, sans-serif;
  justify-content: start;
`;

const ProductTitle = styled.h2`
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.04px;
  margin-top: 10px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export default ItemBox;
